import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { ModalActionTypes } from '@lib/core/models/modal-action-types.enum';
import { Prescription, PrescriptionPlanning, PrescriptionPlanningStatus, PrescriptionTypes } from '@lib/core/models/prescription.interface';
import { Visit } from '@lib/core/models/visit.interface';

import { StatusComponent } from '@lib/shared-ui/commons/status/status.component';

@Component({
  selector: 'hm-appointments-details-modal',
  imports: [MatDialogClose, MatIcon, StatusComponent, MatIconButton, MatSuffix, TranslatePipe],
  templateUrl: './appointments-details-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentsDetailsModalComponent {
  private readonly data: {
    prescriptionData: Prescription;
    plannings: PrescriptionPlanning[];
    appointments: Visit[];
  } = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<AppointmentsDetailsModalComponent>);

  protected readonly formatDate = formatDate;
  protected readonly planningStatus = PrescriptionPlanningStatus;
  protected readonly prescriptionTypes = PrescriptionTypes;

  protected readonly prescription = computed<Prescription>(() => this.data.prescriptionData);
  protected readonly prescriptionPlannings = computed<PrescriptionPlanning[]>(() => this.data.plannings);
  protected readonly expandedDetails = signal<Set<number>>(new Set());

  protected togglePlannedDetails(index: number) {
    const expandedSet = new Set(this.expandedDetails());

    if (expandedSet.has(index)) {
      expandedSet.delete(index);
    } else {
      expandedSet.add(index);
    }
    this.expandedDetails.set(expandedSet);
  }

  protected editAppointment(planningId: string) {
    const selectedAppointment = this.data.appointments.find(appointment => appointment.systemMetadata.appointment_id === planningId);
    this.dialogRef.close({
      type: ModalActionTypes.Edit,
      appointment: selectedAppointment,
    });
  }

  protected cancelAppointment(planningId: string) {
    const selectedAppointment = this.data.appointments.find(appointment => appointment.systemMetadata.appointment_id === planningId);
    this.dialogRef.close({
      type: ModalActionTypes.Delete,
      appointment: selectedAppointment,
    });
  }
}
